import React from "react";
import './RepeatActionConfirmationBox.css'
import { Button } from "@material-ui/core";
import { IRootState } from "../../store";
import { connect } from "react-redux";

export interface IRepeatActionConfirmationBoxProps {
    language: string,
    action: 'edit' | 'delete',
    handleThisOnly: () => void,
    handleThisAndFollowing: () => void,
    handleCancel: () => void
}

export interface IRepeatActionConfirmationBoxState {

}

class IRepeatActionConfirmationBox extends React.Component<IRepeatActionConfirmationBoxProps, IRepeatActionConfirmationBoxState> {
    constructor(props: IRepeatActionConfirmationBoxProps) {
        super(props);
        this.state = {

        }
    }
    render() {
        const isEdit = this.props.action === 'edit';
        return (
            <div className="baseAreaOfRepeatActionConfirmationBox">
                <div className="attentionSignRow">
                    <div className="attentionSign">
                        {this.props.language !== "eng" ? "注意 !" : "Attention!"}
                    </div>
                </div>
                <div className="repeatActionTitle">
                    <h5>
                        {this.props.language !== "eng" 
                            ? (isEdit ? "這是重複課堂，您希望如何修改？" : "這是重複課堂，您希望如何刪除？")
                            : (isEdit ? "This is a repeating class. How would you like to update?" : "This is a repeating class. How would you like to delete?")
                        }
                    </h5>
                </div>

                <div className="repeatActionBtnRow">
                    <Button id="thisOnlyBtn" onClick={this.props.handleThisOnly}>
                        <div>{this.props.language !== "eng" ? (isEdit ? "只修改此堂" : "只刪除此堂") : (isEdit ? "Update This Class Only" : "Delete This Class Only")}</div>
                    </Button>
                    <Button id="thisAndFollowingBtn" onClick={this.props.handleThisAndFollowing}>
                        <div>{this.props.language !== "eng" ? (isEdit ? "修改此堂及之後所有課堂" : "刪除此堂及之後所有課堂") : (isEdit ? "Update This And All Following" : "Delete This And All Following")}</div>
                    </Button>
                    <Button id="cancelBtn" onClick={this.props.handleCancel}>
                        {this.props.language !== "eng" ? "取消" : "Cancel"}
                    </Button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: IRootState) => {
    return {
        language: state.auth.language,
    }
}

export default connect(mapStateToProps, {})(IRepeatActionConfirmationBox);
